// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flex-row[data-v-078b486a]{\n    display: flex;\n}\n.thats-form .md-form .form-control.float-form[data-v-078b486a] {\n    padding: 0.2rem 10px 0.2rem 10px !important;\n}\n", ""]);
// Exports
module.exports = exports;
